import api from '../../../api/index'

export function segmentData(page, keyword){
    return api.get(`cms/segments?${keyword}pageSize=10&pageNumber=${page}`);
}

export function search(keyword){
    return api.get(`cms/segments?keyword=${keyword}&pageSize=10&pageNumber=0`)
}

export function activeStatus(id, active){
    return api.put(`cms/segments/${id}/status?isActive=${active}`)
}

export function segmentDetail(id){
    return api.get(`cms/components/${id}/segment-components`)
}

export function segmentIdDetail(id){
    return api.get(`cms/segments/detail/${id}`)
}


export function editSegment(id, payload){
    return api.put(`cms/segments/${id}`,payload)
}

export function removeSegment(id){
    return api.delete(`cms/segments/${id}`);
}

export function segmentContent(id){
    return api.get(`cms/components/${id}/segment-components`)
}